var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_606_1051",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000915527,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_606_1051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5898 11.3334C28.224 11.3334 28.7843 11.5766 29.2706 12.0629C29.7569 12.5493 30.0001 13.1095 30.0001 13.7437V15.8975C30.0001 16.036 29.9856 16.1855 29.9565 16.3462C29.9274 16.5069 29.8838 16.6565 29.8257 16.7949L26.0052 25.8103C25.8138 26.2376 25.4933 26.5983 25.0437 26.8923C24.5941 27.1864 24.1266 27.3334 23.6411 27.3334H12.8463C12.1813 27.3334 11.6134 27.0979 11.1424 26.6269C10.6715 26.156 10.436 25.5881 10.436 24.9231V12.3309C10.436 12.0095 10.5018 11.7006 10.6334 11.404C10.7651 11.1074 10.9403 10.8497 11.1591 10.6309L18.2129 3.62321C18.4779 3.37194 18.7847 3.21724 19.1334 3.15911C19.4821 3.101 19.8163 3.15314 20.136 3.31554C20.4556 3.47792 20.6864 3.71638 20.8282 4.03091C20.9701 4.34542 20.9983 4.6796 20.9129 5.03344L19.477 11.3334H27.5898ZM5.74376 27.3334C5.07881 27.3334 4.51086 27.0979 4.03993 26.6269C3.56897 26.156 3.3335 25.5881 3.3335 24.9231V13.7437C3.3335 13.0788 3.56897 12.5108 4.03993 12.0399C4.51086 11.5689 5.07881 11.3334 5.74376 11.3334H6.02583C6.69079 11.3334 7.25873 11.5689 7.72966 12.0399C8.2006 12.5108 8.43606 13.0788 8.43606 13.7437V24.9359C8.43606 25.6009 8.2006 26.1667 7.72966 26.6334C7.25873 27.1 6.69079 27.3334 6.02583 27.3334H5.74376Z",
    fill: "#05668D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbActive);
export default __webpack_public_path__ + "static/media/thumb_active.92dfad5708e2bd6e23d1bcc1656f1d91.svg";
export { ForwardRef as ReactComponent };